import { ApplicationsPageContent } from ".";

export default function AllApplicationsPage() {
  return <ApplicationsPageContent activeTab="all" />;
}
